import React, { useState, useEffect } from 'react';
import { fetchActiveLabs } from '../ApiHandler/labFunctions';
import { fetchKendras, saveKendra, deleteKendra } from '../ApiHandler/kendraFunctions';
import { toast, ToastContainer } from 'react-toastify';
import './kendraDetails.css';

const KendraDetails = () => {
    const [labs, setLabs] = useState([]);
    const [kendras, setKendras] = useState([]);
    const [selectedLabId, setSelectedLabId] = useState('');

    const [formData, setFormData] = useState({
        lab_id: '', kendra_name: '', state: '', district: '', block: '', address: '',
        coordinator_name: '', mobile_number: '',
        govt_schools_count: 0, private_schools_count: 0, other_schools_count: 0,
        govt_colleges_count: 0, private_colleges_count: 0, other_colleges_count: 0,
        coaching_institutes_count: 0, ngo_details: '', shg_details: ''
    });

    useEffect(() => {
        fetchActiveLabs(setLabs);
    }, []);

    useEffect(() => {
        if (selectedLabId) {
            setFormData(p => ({ ...p, lab_id: selectedLabId }));
            fetchKendras(selectedLabId, setKendras);
        } else {
            setKendras([]);
        }
    }, [selectedLabId]);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedLabId) return toast.error('Please select a Lab first');
        saveKendra(formData, setKendras, () => setFormData({
            lab_id: selectedLabId, kendra_name: '', state: '', district: '', block: '', address: '',
            coordinator_name: '', mobile_number: '',
            govt_schools_count: 0, private_schools_count: 0, other_schools_count: 0,
            govt_colleges_count: 0, private_colleges_count: 0, other_colleges_count: 0,
            coaching_institutes_count: 0, ngo_details: '', shg_details: ''
        }));
    };

    const statesList = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana",
        "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
        "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
        "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands", "Chandigarh",
        "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
    ];

    return (
        <div className="kendra-page">
            <ToastContainer />
            <div className="header-row">
                <h2>Kendra Details</h2>
                <select value={selectedLabId} onChange={e => setSelectedLabId(e.target.value)} className="lab-dropdown">
                    <option value="">-- Select Lab --</option>
                    {labs.map(l => <option key={l.id} value={l.id}>{l.lab_name}</option>)}
                </select>
            </div>

            {selectedLabId ? (
                <>
                    <form className="kendra-form-box" onSubmit={handleSubmit}>
                        <div className="form-grid">
                            <div className="input-group">
                                <label>Kendra Name *</label>
                                <input type="text" name="kendra_name" value={formData.kendra_name} onChange={handleChange} required />
                            </div>
                            <div className="input-group">
                                <label>State *</label>
                                <select name="state" value={formData.state} onChange={handleChange} required>
                                    <option value="" disabled>Select State</option>
                                    {statesList.map(state => <option key={state} value={state}>{state}</option>)}
                                </select>
                            </div>
                            <div className="input-group">
                                <label>District *</label>
                                <input type="text" name="district" value={formData.district} onChange={handleChange} required />
                            </div>
                            <div className="input-group">
                                <label>Block</label>
                                <input type="text" name="block" value={formData.block} onChange={handleChange} />
                            </div>
                            <div className="input-group">
                                <label>Address</label>
                                <input type="text" name="address" value={formData.address} onChange={handleChange} />
                            </div>
                            <div className="input-group">
                                <label>Coordinator Name</label>
                                <input type="text" name="coordinator_name" value={formData.coordinator_name} onChange={handleChange} />
                            </div>
                            <div className="input-group">
                                <label>Mobile Number</label>
                                <input type="text" name="mobile_number" value={formData.mobile_number} onChange={handleChange} />
                            </div>
                        </div>

                        <h4 className="section-title">Nearby Details (10 KM Radius)</h4>
                        <div className="form-grid">
                            <div className="input-group">
                                <label>Govt Schools Count</label>
                                <input type="number" name="govt_schools_count" value={formData.govt_schools_count} onChange={handleChange} min="0" />
                            </div>
                            <div className="input-group">
                                <label>Private Schools Count</label>
                                <input type="number" name="private_schools_count" value={formData.private_schools_count} onChange={handleChange} min="0" />
                            </div>
                            <div className="input-group">
                                <label>Other Schools Count</label>
                                <input type="number" name="other_schools_count" value={formData.other_schools_count} onChange={handleChange} min="0" />
                            </div>
                            <div className="input-group">
                                <label>Govt Colleges Count</label>
                                <input type="number" name="govt_colleges_count" value={formData.govt_colleges_count} onChange={handleChange} min="0" />
                            </div>
                            <div className="input-group">
                                <label>Private Colleges Count</label>
                                <input type="number" name="private_colleges_count" value={formData.private_colleges_count} onChange={handleChange} min="0" />
                            </div>
                            <div className="input-group">
                                <label>Other Colleges Count</label>
                                <input type="number" name="other_colleges_count" value={formData.other_colleges_count} onChange={handleChange} min="0" />
                            </div>
                            <div className="input-group">
                                <label>Coaching Institutes Count</label>
                                <input type="number" name="coaching_institutes_count" value={formData.coaching_institutes_count} onChange={handleChange} min="0" />
                            </div>
                        </div>

                        <h4 className="section-title">Community Details</h4>
                        <div className="form-grid">
                            <div className="input-group">
                                <label>NGO Details</label>
                                <input type="text" name="ngo_details" value={formData.ngo_details} onChange={handleChange} />
                            </div>
                            <div className="input-group">
                                <label>SHG Details</label>
                                <input type="text" name="shg_details" value={formData.shg_details} onChange={handleChange} />
                            </div>
                        </div>

                        <div className="form-actions">
                            <button type="submit" className="save-btn">Save Kendra</button>
                        </div>
                    </form>

                    <div className="kendras-list-box">
                        <div className="list-header">
                            <h3>Existing Kendras</h3>
                        </div>
                        <div className="table-responsive">
                            <table className="kendra-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>State</th>
                                        <th>Coordinator</th>
                                        <th>Mobile</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {kendras.map(k => (
                                        <tr key={k.id}>
                                            <td>{k.id}</td>
                                            <td>{k.kendra_name}</td>
                                            <td>{k.state}</td>
                                            <td>{k.coordinator_name}</td>
                                            <td>{k.mobile_number}</td>
                                            <td>
                                                <button className="del-btn" onClick={() => deleteKendra(k.id, selectedLabId, setKendras)}>Delete</button>
                                            </td>
                                        </tr>
                                    ))}
                                    {kendras.length === 0 && (
                                        <tr><td colSpan="6" style={{textAlign:'center', padding:'20px'}}>No kendras found</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            ) : (
                <div className="kendra-placeholder">Please select a Lab to manage its Kendras.</div>
            )}

            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', borderLeft: '4px solid #6C5CE7', fontSize: '13px', color: '#555' }}>
                <i className='bx bx-shield-quarter' style={{ marginRight: '8px', color: '#6C5CE7' }}></i>
                <strong>Role-Based Access:</strong> To ensure data privacy, Teachers can only view records mapped to their assigned Lab or School, or records they have personally added. District Officers can view all records within their assigned District. Admin has global access.
            </div>
        </div>
    );
};

export default KendraDetails;
